'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_TIMEOUT = 3000;
var DEFAULT_PROPS = {};

function middleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getState = options.getState,
      _options$timeout = options.timeout,
      globalTimeout = _options$timeout === undefined ? DEFAULT_TIMEOUT : _options$timeout,
      _options$props = options.props,
      globalProps = _options$props === undefined ? DEFAULT_PROPS : _options$props;
  if (getState) throw new Error('redux-flash: Middleware must be initialized as a function.');
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== actions.FLASH_MESSAGE_ACTION_TYPE) return next(action);
        var _action$payload = action.payload,
            message = _action$payload.message,
            _action$payload$optio = _action$payload.options,
            _action$payload$optio2 = _action$payload$optio.push,
            push = _action$payload$optio2 === undefined ? false : _action$payload$optio2,
            _action$payload$optio3 = _action$payload$optio.isError,
            isError = _action$payload$optio3 === undefined ? false : _action$payload$optio3,
            _action$payload$optio4 = _action$payload$optio.timeout,
            timeout = _action$payload$optio4 === undefined ? globalTimeout : _action$payload$optio4,
            _action$payload$optio5 = _action$payload$optio.props,
            props = _action$payload$optio5 === undefined ? {} : _action$payload$optio5;
        var id = (0, _v2.default)();
        if (push) next(actions.clearMessages());
        next(actions._addMessage({
          id: id,
          message: message,
          isError: isError,
          props: _extends({}, globalProps, props)
        }));
        if (timeout) setTimeout(function () {
          return next(actions.removeMessage(id));
        }, timeout);
      };
    };
  };
}

exports.default = middleware;